module.exports = __webpack_public_path__ + "img/stone.265b22fc.png";